import { useObserver } from 'mobx-react-lite'
import { useService } from 'services/utils/context'
import { css } from 'styled-components'
import { AssetImageType } from 'uiComponents/organisms/AssetGrid/AssetGrid'

const customAssetStyles = css`
  opacity: 0.5;
  transition: opacity 0.5s ease-in, filter 0.5s ease-in;
  filter: grayscale(1);
  min-width: 100%;

  :hover {
    opacity: 0.8;
    filter: grayscale(0.5);
  }
`

export const useAssetList = (): AssetImageType[] => {
  const service = useService()
  const placeholders = useObserver(() => service.blackFriday.getPlaceholders())

  return [
    {
      src: placeholders['{{BF-LP-CAT1-IMG}}']
        ? placeholders['{{BF-LP-CAT1-IMG}}']
        : require('assets/images/blackFriday/blackFriday-Jacken.jpg'),
      customStyles: customAssetStyles,
      alt: placeholders['{{BF-LP-CAT1-TEXT}}'],
      label: placeholders['{{BF-LP-CAT1-TEXT}}'],
      to: placeholders['{{BF-LP-CAT1-LINK}}'],
    },
    {
      src: placeholders['{{BF-LP-CAT2-IMG}}']
        ? placeholders['{{BF-LP-CAT2-IMG}}']
        : require('assets/images/blackFriday/blackFriday-Kleider.jpg'),
      customStyles: customAssetStyles,

      alt: placeholders['{{BF-LP-CAT2-TEXT}}'],
      label: placeholders['{{BF-LP-CAT2-TEXT}}'],
      to: placeholders['{{BF-LP-CAT2-LINK}}'],
    },
    {
      src: placeholders['{{BF-LP-CAT3-IMG}}']
        ? placeholders['{{BF-LP-CAT3-IMG}}']
        : require('assets/images/blackFriday/blackFriday-Jeans.jpg'),
      customStyles: customAssetStyles,
      alt: placeholders['{{BF-LP-CAT3-TEXT}}'],
      label: placeholders['{{BF-LP-CAT3-TEXT}}'],
      to: placeholders['{{BF-LP-CAT3-LINK}}'],
    },
    {
      src: placeholders['{{BF-LP-CAT4-IMG}}']
        ? placeholders['{{BF-LP-CAT4-IMG}}']
        : require('assets/images/blackFriday/blackFriday-Pullover.jpg'),
      customStyles: customAssetStyles,
      alt: placeholders['{{BF-LP-CAT4-TEXT}}'],
      label: placeholders['{{BF-LP-CAT4-TEXT}}'],
      to: placeholders['{{BF-LP-CAT4-LINK}}'],
    },
    {
      src: placeholders['{{BF-LP-CAT5-IMG}}']
        ? placeholders['{{BF-LP-CAT5-IMG}}']
        : require('assets/images/blackFriday/blackFriday-Schuhe.jpg'),
      customStyles: customAssetStyles,
      alt: placeholders['{{BF-LP-CAT5-TEXT}}'],
      label: placeholders['{{BF-LP-CAT5-TEXT}}'],
      to: placeholders['{{BF-LP-CAT5-LINK}}'],
    },
    {
      src: placeholders['{{BF-LP-CAT6-IMG}}']
        ? placeholders['{{BF-LP-CAT6-IMG}}']
        : require('assets/images/blackFriday/blackFriday-Shirts.jpg'),
      customStyles: customAssetStyles,
      alt: placeholders['{{BF-LP-CAT6-TEXT}}'],
      label: placeholders['{{BF-LP-CAT6-TEXT}}'],
      to: placeholders['{{BF-LP-CAT6-LINK}}'],
    },
  ]
}
